import { render } from "./PancreasSpecificSectionDetailsEMROATS.vue?vue&type=template&id=adf2af3e&scoped=true"
import script from "./PancreasSpecificSectionDetailsEMROATS.vue?vue&type=script&lang=js"
export * from "./PancreasSpecificSectionDetailsEMROATS.vue?vue&type=script&lang=js"

import "./PancreasSpecificSectionDetailsEMROATS.vue?vue&type=style&index=0&id=adf2af3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf2af3e"],['__file',"src/components/PancreasSpecificSectionDetailsEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "adf2af3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('adf2af3e', __exports__)) {
    api.reload('adf2af3e', __exports__)
  }
  
  module.hot.accept("./PancreasSpecificSectionDetailsEMROATS.vue?vue&type=template&id=adf2af3e&scoped=true", () => {
    api.rerender('adf2af3e', render)
  })

}


export default __exports__